import { get, post } from '@/utils/request'

const tfApi = {
  getZkApi: '/api/admin/tnb/zk',
  dubboApi: '/api/admin1/zookeeper',
  springCloudApi: '/api/admin1/nacos',
  gatewayRouteApi: '/api/admin1/gateway',
  logApi: '/api/admin1/log',
  getArticlesApi: '/api/content/admin/video/all'
}

export function getZkList() {
  return get(tfApi.dubboApi + '/list')
}

export function getDubboList() {
  return get(tfApi.dubboApi + '/dubbo')
}

export function getSpringCloudServices() {
  return get(tfApi.springCloudApi + '/services')
}

export function getSpringCloudInstances(queryParams) {
  return get(tfApi.springCloudApi + '/instances', queryParams)
}

export function getGatewayRoute() {
  return get(tfApi.gatewayRouteApi + '/route')
}

export function getAccessLog() {
  return get(tfApi.logApi + '/access')
}
